import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import cx from "classnames";
import { withRouter } from "react-router-dom";
import {
  Button,
  CardHeader,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TitleComponent1 from "./PageTitleExamples/Variation1";
import TitleComponent2 from "./PageTitleExamples/Variation2";
import TitleComponent3 from "./PageTitleExamples/Variation3";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import {
  AddNewButton,
  RefreshButton,
  ExportExcelButton,
  FilterButton,
  PrintButton,
  DeleteButton,
} from "../../Components/Button";
import CustomTooltip from "../../Components/Tooltip";
import { withTranslation } from "react-i18next";
import PopConfirm from "../../Components/PopConfirm";
class PageTitle extends Component {
  randomize(myArray) {
    return myArray[Math.floor(Math.random() * myArray.length)];
  }
  render() {
    let {
      enablePageTitleIcon,
      enablePageTitleSubheading,
      heading,
      icon,
      subheading,
      onClickFilter,
      useFilter,
      disabledFilter,
      useAddNew,
      disablePermissionAdd,
      disablePermissionRefresh,
      disablePermissionExportCSV,
      onClickAddNew,
      useRefresh,
      onClickRefresh,
      useExportCSV,
      onClickExportCSV,
      loading,
      setLoading,
      endElement,
      startElement,
      useButtonHandle,
      onButtonHandle,
      isPageStatistic,
      startButtonElement,
      pageTitleBackgroundColor,
      usePrint,
      onClickPrint,
      useDelete,
      disablePermissionDelete,
      onClickDelete,
      autoCloseDelete,
      stopPropagationDelete,
      t,
    } = this.props;

    var Router = withRouter(({ history, location }) => {
      console.log(history);
    });
    var arr = [<TitleComponent1 />, <TitleComponent2 />, <TitleComponent3 />];
    return (
      <div
        className={cx("app-page-title", pageTitleBackgroundColor)}
        style={
          isPageStatistic ? { paddingLeft: "30px" } : { paddingLeft: "15px" }
        }
      >
        <div className="page-title-wrapper" style={{ display: "block" }}>
          <div
            className="page-title-heading"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: "10px",
              paddingBottom: "10px"
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <div
                className={cx("page-title-icon", {
                  "d-none": !enablePageTitleIcon,
                })}
                style={{
                  marginRight: "10px",
                  width: "40px",
                  height: "40px",
                  padding: "0px",
                  opacity: 0.85,
                }}
              >
                <i className={icon} style={{ fontSize: "1.4rem" }} />
              </div> */}
              <div style={{ fontSize: "1rem", fontWeight: "500" }}>
                {heading && heading.toUpperCase()}
                <div
                  className={cx("page-title-subheading", {
                    "d-none": !enablePageTitleSubheading,
                  })}
                ></div>
              </div>
            </div>
            {startElement}
            <div className="d-flex align-items-center justify-content-center">
              {startButtonElement}
              {useFilter ? (
                <div>
                  <FilterButton
                    onClick={onClickFilter}
                    className="btn-hover-shine mr-2"
                    disabled={disabledFilter}
                  />
                </div>
              ) : (
                null
              )}
              {useAddNew ? (
                <div>
                  <AddNewButton
                    className="btn-hover-shine mr-2"
                    onClick={onClickAddNew}
                    disabled={disablePermissionAdd}
                  />
                </div>
              ) : (
                null
              )}
              {useRefresh ? (
                <div>
                  <RefreshButton
                    loading={loading}
                    className="btn-hover-shine mr-2"
                    onClick={() => {
                      onClickRefresh();
                      if (setLoading) {
                        setLoading(true);
                        setTimeout(() => {
                          setLoading(false);
                        }, 2000);
                      }
                    }}
                    disabled={disablePermissionRefresh}
                  />
                </div>
              ) : (
                null
              )}
              {useExportCSV ? (
                <div>
                  <ExportExcelButton
                    block
                    className="btn-hover-shine mr-2"
                    onClick={(e) => {
                      if (
                        onClickExportCSV &&
                        typeof onClickExportCSV === "function"
                      ) {
                        onClickExportCSV(e);
                      }
                    }}
                    disabled={disablePermissionExportCSV}
                  />
                </div>
              ) : (
                null
              )}
              {useDelete ? (
                <div>
                  <PopConfirm
                    onOK={onClickDelete}
                    placement="bottom"
                    type="danger"
                    title={t("Warning")}
                    content={t("Do you really want to delete?")}
                    autoCloseDelete={autoCloseDelete}
                    stopPropagationDelete
                  >
                    <DeleteButton
                      className="btn-hover-shine mr-2"
                      onClick={(e) => {
                        if (stopPropagationDelete) {
                          e.stopPropagation();
                        }
                      }}
                      disabled={disablePermissionDelete}
                    />
                  </PopConfirm>
                </div>
              ) : (
                null
              )}
              {endElement}
              {useButtonHandle ? (
                <Button
                  block
                  className="mb-2 mr-2 btn-icon right"
                  onClick={onButtonHandle}
                  color="primary"
                >
                  <i class="fas fa-circle-plus" style={{ fontSize: 16 }}></i>
                </Button>
              ) : (
                null
              )}
              {usePrint ? (
                <div>
                  <PrintButton
                    block
                    className="btn-hover-shine mr-2"
                    onClick={(e) => {
                      if (onClickPrint && typeof onClickPrint === "function") {
                        onClickPrint();
                      }
                    }}
                  />
                </div>
              ) : (
                null
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  enablePageTitleIcon: state.ThemeOptions.enablePageTitleIcon,
  enablePageTitleSubheading: state.ThemeOptions.enablePageTitleSubheading,
  pageTitleBackgroundColor: state.ThemeOptions.pageTitleBackgroundColor,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["configure"])(PageTitle));
